"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SyncSupplier_1 = require("@twii/core/lib/model/SyncSupplier");
var ListingDeleteStore = new SyncSupplier_1.SyncSupplier();
exports.ListingDeleteStore = ListingDeleteStore;
